import { IMultiChainCompoundValue } from '../types';

export function getInitialMultiChainCompoundValue(prefilledInput?: string): IMultiChainCompoundValue {
    const initialRows: Record<number, Record<number, string>> = {};

    for (let i = 0; i < 100; i += 1) {
        initialRows[i] = { 0: '', 1: '', 2: '' };
    }

    if (prefilledInput) {
        initialRows[0] = { 0: '', 1: prefilledInput.trim(), 2: '' };
    }

    return {
        filename: null,
        rows: initialRows,
    };
}
